<ng-container *ngIf="mixedLoyaltyItems$ | async as mixedLoyaltyItems">
  <ng-container *ngIf="mixedLoyaltyItems.length">
    <div class="featured-rewards-bg d-flex">
      <div class="container my-auto px-0">
        <div>
          <div class="d-flex flex-row justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <ng-container *ngIf="showTitleIcon">
                <span class="icon material-icons featured-rewards-icon me-2">{{ featuredIcon }}</span>
              </ng-container>
              <h5 class="featured-rewards-heading fgbcl-subheading-title">
                {{ title || ('home.page.featured.rewards.title' | translate) }}
              </h5>
            </div>
            <a
              class="featured-rewards-show-all text-nowrap d-flex align-items-center"
              [routerLink]="showAllPath"
              [attr.aria-label]="'fbcl.featured.rewards.show.all.screenreader' | translate"
            >
              <span class="featured-rewards-text">{{ 'featured.rewards.show.all' | translate }}</span>
              <span class="font-size-14 icon material-icons show-all-icon ps-2 fw-bold" aria-hidden="true"
                >arrow_forward_ios</span
              >
            </a>
          </div>
          <ng-container *ngIf="mixedLoyaltyItems?.length > 0">
            <div id="rewards-carousel">
              <owl-carousel-o [options]="customOptions()" (dragging)="isDragging = $event.dragging">
                <ng-container *ngFor="let item of mixedLoyaltyItems">
                  <ng-template carouselSlide [width]="mixedLoyaltyItems.length <= 2 ? rewardsWidth : 0">
                    <fgbcl-mixed-loyalty-item
                      [item]="item"
                      [ignoreLink]="isDragging"
                      [featuredIcon]="featuredIcon"
                    ></fgbcl-mixed-loyalty-item>
                  </ng-template>
                </ng-container>
              </owl-carousel-o>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
